<app-header [showHamburger]="false"></app-header>

<mat-sidenav-container autosize="true">
  <mat-sidenav mode="side" [opened]="true">
    <mat-nav-list>
      @for (tab of visibleTabs(); track tab) {
        <a
          mat-list-item
          (click)="activeNavItem = tab.path"
          [attr.data-testid]="tab.path"
          [target]="tab.target"
          [routerLinkActive]="'active-route'"
          [routerLinkActiveOptions]="{ exact: true }"
          [routerLink]="[tab.prefix, tab.path]"
          [disableRipple]="true"
        >
          <span class="flex items-center gap-2 route-label">
            <mat-icon>{{ tab.icon }}</mat-icon>
            {{ tab.title }}
          </span>
        </a>
      }
    </mat-nav-list>
  </mat-sidenav>
  <mat-sidenav-content>
    <div class="pt-4 pb-20 h-screen overflow-y-auto">
      <router-outlet></router-outlet>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
